import styled from 'styled-components';

import { Loading } from 'components/Loading';

const StyledLoading = styled(Loading)`
  margin: 0 auto;
`;

export default StyledLoading;
